<div class="row row-cols-2 row-cols-xl-3 g-3 list-unstyled m-0 p-0 w-100">
  <div class="col" *ngFor="let field of fields | keyvalue">
    <rl-add-field-button
      [field]="field.value"
      [hasPartOfResource]="hasPartOfResource"
      [label]="field.value.label"
      [addToMainResourceEnabled]="
        field.value.isIterable || !visibleFields.mainResource.fields[field.key]
      "
      [addToPartOfResourceEnabled]="
        field.value.isIterable ||
        !visibleFields.partOfResource.fields[field.key]
      "
      (addedField)="addFieldToForm($event)"
    ></rl-add-field-button>
  </div>
</div>
